var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanneryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 48,
    viewBox: "0 0 43 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6835 32.8081C17.6157 32.8081 19.5481 32.8231 21.4803 32.805C26.6514 32.7577 30.7881 29.0214 31.8235 24.2461C32.0606 23.1517 32.1441 22.046 32.0529 20.9302C31.6433 15.9387 28.1103 12.1111 23.7655 11.117C22.7018 10.8737 21.627 10.7867 20.5417 10.8809C15.6905 11.3013 11.9674 14.9361 11.0008 19.4048C10.8194 20.2431 10.7354 21.0908 10.7351 21.9481C10.7339 25.4837 10.7345 29.0193 10.7345 32.5546C10.7345 32.6303 10.7345 32.7057 10.7345 32.8009C11.5209 32.8009 12.2836 32.8009 13.0672 32.8009C13.0678 32.7941 13.0681 32.7877 13.0684 32.7809H15.499C15.499 32.79 15.499 32.7994 15.499 32.8081C15.5627 32.8081 15.6229 32.8081 15.6835 32.8081Z",
    fill: "url(#paint0_linear_16289_29662)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0136 19.8785C41.2068 10.0415 34.2438 2.49732 25.6812 0.538434C23.5845 0.0588851 21.4663 -0.112025 19.3278 0.0729711C9.76675 0.901852 2.42944 8.06504 0.524659 16.8719C0.167075 18.5243 0.00152163 20.1949 0.000912981 21.8844C0.000912981 21.9392 0.000912981 21.9942 0.000912981 22.0493H0C0 28.6741 0 35.2989 0 41.9237C0 42.2116 0 42.4996 0 42.7877C0 42.9366 0 43.0856 0 43.2728C0 44.7149 0 46.157 0 47.5991C0 47.7321 0 47.8664 0 48H4.61695C4.61725 47.9018 4.61908 47.8032 4.61908 47.7049C4.61908 45.7497 4.61908 43.7943 4.61908 41.8391C4.61998 35.1239 4.61938 28.4083 4.62029 21.6931C4.62151 13.7874 9.8964 6.93379 17.3847 5.1843C26.4624 3.06233 35.1829 9.03917 37.0849 18.0738C39.0119 27.2279 33.2553 36.3581 24.3562 38.1689C23.2192 38.4003 22.043 38.4901 20.882 38.5195C20.8646 38.5199 20.8473 38.5199 20.8302 38.5205L20.8294 38.5195H9.38969C9.38969 40.1068 9.38969 41.6924 9.38969 43.2871C9.51478 43.2871 9.63376 43.2871 9.75276 43.2871C13.5611 43.2871 17.3697 43.3164 21.1778 43.2815C31.3684 43.1877 39.5211 35.8251 41.5613 26.4128C42.0287 24.2568 42.194 22.0778 42.0136 19.8785Z",
    fill: "url(#paint1_linear_16289_29662)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16289_29662",
    x1: 10.7344,
    y1: 10.8437,
    x2: 10.7344,
    y2: 32.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5295DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16289_29662",
    x1: 0.276525,
    y1: 0.630781,
    x2: 0.276525,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5295DA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanneryIcon);
export default __webpack_public_path__ + "static/media/plannery-icon.009583fadb7a369f525c259e501d659a.svg";
export { ForwardRef as ReactComponent };